/**
 * ModuleFederationPlugin requires that the entry file must asyncronously
 * initialize the root module. This fulfills that requirement
 */
import('#client/directEntry');
